import { SnLonLat } from '@lib/geo/helpers';

import { IBaseMarkerEvents } from './base-marker-events';
import { GoogleMapMarkerType } from './marker-types';

export interface IGoogleMapMarkerEvents extends IBaseMarkerEvents {
  typeChange: GoogleMapMarkerType;
  draggableChange: boolean;
  styleChange: undefined;
  dragstart: undefined;
  drag: SnLonLat;
  dragend: SnLonLat;
}
